import { parse, stringify } from "query-string";
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
import { match } from "react-router-dom";
import { Location } from "history";

interface ParsedQueryStringResult {
  [key: string]: string[] | string | null | undefined;
}

export const parseQueryString = (
  querystring: string
): ParsedQueryStringResult => parse(querystring.replace(/^\?/, ""));

export const getPassageId = ({ location }: { location: Location }): string => {
  const queryParams = parseQueryString(location.search);

  return "" + queryParams.passageId;
};

interface ChapterPathQueryParms {
  removedPassageId?: string;
  [key: string]: any;
}

export const chapterPath = ({
  bibleId,
  chapterId,
  passageId,
  location
}: {
  bibleId: string;
  chapterId: string;
  passageId?: string;
  location?: Location;
}) => {
  let queryParams = {} as ChapterPathQueryParms;
  if (location) {
    queryParams = parseQueryString(location.search);
  }

  const { passageId: removedPassageId, ...restOfParams } = queryParams;
  const newParams = {
    ...restOfParams,
    passageId
  };
  const path = `/bible/${bibleId}/${chapterId}?${stringify(newParams)}`;
  return path;
};

export const removeAllParallels = ({ location }: { location: Location }) => {
  const { parallels, ...queryParams } = parseQueryString(location.search);
  return `${location.pathname}?${stringify(queryParams)}`;
};

export const removeParallel = ({
  parallelIndex,
  location
}: {
  parallelIndex: number;
  location: Location;
}) => {
  const queryParams = parseQueryString(location.search);
  const parallels =
    queryParams.parallels && typeof queryParams.parallels === "string"
      ? queryParams.parallels.split(",")
      : [];

  const newParallels = [
    ...parallels.slice(0, parallelIndex),
    ...parallels.slice(parallelIndex + 1, parallels.length)
  ];
  const newParams = {
    ...queryParams,
    parallels: newParallels.length ? newParallels.join(",") : undefined
  };
  const path = `${location.pathname}?${stringify(newParams)}`;
  return path;
};

export const addParallel = ({
  parallelId,
  location
}: {
  parallelId: string;
  location: Location;
}) => {
  const queryParams = parseQueryString(location.search);
  const parallels =
    queryParams.parallels && typeof queryParams.parallels === "string"
      ? queryParams.parallels.split(",")
      : [];

  const newParallels = [...parallels, parallelId];
  const newParams = {
    ...queryParams,
    parallels: newParallels.length ? newParallels.join(",") : undefined
  };
  const path = `${location.pathname}?${stringify(newParams)}`;
  return path;
};

export const getParallels = (querystring: string) => {
  const { parallels } = parseQueryString(querystring);
  if (typeof parallels === "string") return parallels.split(",");
  return [];
};

export const updatePagination = ({
  location,
  offset,
  limit
}: {
  location: Location;
  offset: number;
  limit: number;
}) => {
  const queryParams = parseQueryString(location.search);
  const newParams = {
    ...queryParams,
    offset,
    limit
  };
  return `${location.pathname}?${stringify(newParams)}`;
};

export const changeBible = ({
  location,
  match,
  bibleId,
  parallelIndex
}: {
  location: Location;
  match: match<{ chapterId: string }>;
  bibleId: string;
  parallelIndex?: number;
}) => {
  const { params } = match;
  if (parallelIndex === undefined || parallelIndex === null) {
    const newPath = `/bible/${bibleId}/${params.chapterId}`;
    return `${newPath}${location.search}`;
  }
  const queryParams = parseQueryString(location.search);
  const parallels =
    queryParams.parallels && typeof queryParams.parallels === "string"
      ? queryParams.parallels.split(",")
      : [];
  const newParams = {
    ...queryParams,
    parallels: [
      ...parallels.slice(0, parallelIndex),
      bibleId,
      ...parallels.slice(parallelIndex + 1, parallels.length)
    ].join(",")
  };
  return `${match.url}?${stringify(newParams)}`;
};
